import { Modal, ModalHeader } from 'baseui/modal'
import { Search } from 'baseui/icon'
import { SIZE } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import usePdlSearchV2 from './usePdlSearchV2'
import PdlSearchForm from './PdlSearchForm'
import PdlSearchResults from './PdlSearchResults'

const PdlSearchModal = () => {
  const { t } = useTranslation()
  const { isOpen, currentViewPage, resetPdlSearchData, updatePdlConfigData } = usePdlSearchV2()

  const handleClose = () => {
    updatePdlConfigData({ isOpen: false })
    resetPdlSearchData()
  }

  return (
    <Modal
      onClose={handleClose}
      isOpen={isOpen}
      size={SIZE.auto}
      overrides={{
        Dialog: {
          style: {
            width: 'auto',
            maxWidth: '90vw',
          },
        },
      }}
    >
      <ModalHeader
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          backgroundColor: '#f7f7f7',
          borderBottom: '0.0625rem solid #e0e0e0',
          padding: '1rem 1.5rem',
        }}
      >
        <Search size={21} />
        {t('subscriptionTools:pdl_search.module_title')}
      </ModalHeader>

      {currentViewPage === 'search' && <PdlSearchForm />}
      {currentViewPage === 'results' && <PdlSearchResults />}
    </Modal>
  )
}

export default PdlSearchModal
